import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import {
  getTranslatedKeyInitiativeStatusOptions,
  STATUS_OPTIONS,
} from 'partner360/entities/keyInitiatives/model/status'

export const createStatusCrud = (translate: (key: string) => string) =>
  new Crud({
    fetcher: new Static(
      getTranslatedKeyInitiativeStatusOptions(translate).sort((a, b) => a.key.localeCompare(b.key))
    ),
    keyField: 'key',
    defaultPaging: {
      page: 0,
      pageSize: STATUS_OPTIONS.length,
    },
  })
